/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon24Regular = forwardRef('ArrowUiCornerOutUpRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.5 3.75A2.75 2.75 0 0 0 3.75 6.5v11a2.75 2.75 0 0 0 2.75 2.75h11a2.75 2.75 0 0 0 2.75-2.75V15a.75.75 0 0 1 1.5 0v2.5a4.25 4.25 0 0 1-4.25 4.25h-11a4.25 4.25 0 0 1-4.25-4.25v-11A4.25 4.25 0 0 1 6.5 2.25H9a.75.75 0 0 1 0 1.5H6.5Z" }),
        React.createElement("path", { d: "M20.25 4.81V10a.75.75 0 0 0 1.5 0V3.5c0-.69-.56-1.25-1.25-1.25H14a.75.75 0 0 0 0 1.5h5.19l-8.22 8.22a.75.75 0 1 0 1.06 1.06l8.22-8.22Z" })));
});
